// extracted by mini-css-extract-plugin
export default {"ColSty":"CurrentMonthIncome_ColSty__A8UIZ"};